module.exports = __webpack_public_path__ + "static/media/arrow-down.e0d18dc1.svg";